/**
 * Formats character length for display
 * @param length - The character length
 * @returns Formatted string (e.g., "1.2K chars", "15K chars", "123 chars")
 */
export function formatCharacterLength(length: number | undefined): string {
  if (!length || length === 0) return "0 chars";

  if (length < 1000) {
    return `${length} chars`;
  } else if (length < 1000000) {
    return `${(length / 1000).toFixed(1)}K chars`;
  } else {
    return `${(length / 1000000).toFixed(1)}M chars`;
  }
}

/**
 * Calculates compression ratio as a percentage
 * @param original - Original length
 * @param compressed - Compressed length
 * @returns Formatted percentage (e.g., "25% of original")
 */
export function formatCompressionRatio(original: number | undefined, compressed: number | undefined): string {
  if (original === undefined || compressed === undefined || original === 0) return "";

  const ratio = (compressed / original) * 100;
  return `${Math.round(ratio)}% of original`;
}
